import React from 'react';
import { Grid } from '@material-ui/core';

import Title from 'components/typography/Title';
import CoverPhotoInput from './cover_photo/CoverPhotoInput';
import DescriptionInput from './description/DescriptionInput';
import ServingsInput from './servings/ServingsInput';
import NutricionalDataInput from './nutricional_data/NutricionalDataInput';

const AdditionalDataInput = ({
  additionalData,
  onAdditionalDataChange,
  errorMessages,
}) => {
  const _extractKey = (key) => {
    if (!errorMessages) return null;
    return errorMessages[key];
  };

  return (
    <Grid container direction="column">
      <Grid item>
        <Title>Additional Data</Title>
      </Grid>

      <Grid item style={{ marginTop: 32 }}>
        <CoverPhotoInput
          coverPhoto={additionalData.coverPhotoURL}
          setCoverPhoto={(coverPhotoURL) =>
            onAdditionalDataChange({ ...additionalData, coverPhotoURL })
          }
        ></CoverPhotoInput>
      </Grid>

      <Grid item style={{ marginTop: 32 }}>
        <DescriptionInput
          description={additionalData.description}
          setDescription={(description) =>
            onAdditionalDataChange({ ...additionalData, description })
          }
          errorMessage={_extractKey('description')}
        ></DescriptionInput>
      </Grid>

      <Grid item style={{ marginTop: 32 }}>
        <ServingsInput
          servings={additionalData.servings}
          setServings={(servings) =>
            onAdditionalDataChange({ ...additionalData, servings })
          }
          errorMessage={_extractKey('servings')}
        ></ServingsInput>
      </Grid>

      <Grid item style={{ marginTop: 32, marginBottom: 16 }}>
        <NutricionalDataInput
          nutricionalData={additionalData.nutricionalData}
          setNutricionalData={(nutricionalData) =>
            onAdditionalDataChange({ ...additionalData, nutricionalData })
          }
          errorMessages={_extractKey('nutricionalData')}
        ></NutricionalDataInput>
      </Grid>
    </Grid>
  );
};

export default AdditionalDataInput;
